<template>
    <div>
        <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

        <v-container fluid> 

            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Parámetros especiales.</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br>             

            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <span class="title primary--text">Contratos</span>
                </v-col>    
            </v-row>       

            <v-row class="ml-3">               
                <v-col cols="12" sm="12" md="2">
                    <v-text-field label="Monto por hora sin iva" :rules="[rules.moneda]" type="number" hide-spin-buttons v-model="contrato_monto_por_hora" prefix="$"  outlined dense></v-text-field>
                </v-col>
            </v-row>

            <v-row class="d-flex justify-end">
                <v-col cols="12" sm="12" md="1" class="d-flex justify-end">
                    <v-btn color="primary" @click="guardar()" block dense>Guardar</v-btn>
                </v-col>
            </v-row>

    
            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>        
    
        </v-container>
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";

export default {

    components:{
        menulateral,
        barraprincipaladmin,
    },

    data() {
        return {
            menu_visible: false,

            snackbartexto: "",
            snackbar: false,            
            snackbarcolor: "", 

            contrato_monto_por_hora: 0.0,


            rules:{                                
                moneda: value => {                    
                    const pattern = /^[0-9]{1,6}([\\.][0-9]{1,2})/
                    let valido = pattern.test(value)
                    return valido || 'Formato de moneda no valido.'
                }, 
            }

        }
    },  
    
    created() {
        this.consultaParametros()
    },
    
    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        }, 

        consultaParametros(){
            let token = sessionStorage.getItem('datax')

            this.axios.get(this.$url+"/admin/parametros_especiales/listado", {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{

                    const data = response.data

                    if(!data.error){
                        for(let par of data.parametros){
                            if(par.parametro == 'monto_por_hora')
                                this.contrato_monto_por_hora = parseFloat(par.valor)
                        }
                    }


                })
                .catch((error)=>{
                    console.log(error);
                })
        },

        actualizarParametro(modulo, parametro, valor){
            let token = sessionStorage.getItem('datax')

            let datos = {
                modulo: modulo,
                parametro: parametro,
                valor: valor
            }

            this.axios.put(this.$url+"/admin/parametros_especiales/actualizar", {datos:datos}, {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{

                    const data = response.data

                    if(!data.error){
                        this.snackbar = true
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'success'
                    }
                    else{
                        this.snackbar = true
                        this.snackbartexto = data.mensaje
                        this,this.snackbarcolor = 'error'
                    }


                })
                .catch((error)=>{
                    console.log(error);
                })
        },

        guardar(){            

            this.actualizarParametro('contratos', 'monto_por_hora', this.contrato_monto_por_hora)

            //    console.log(this.contrato_monto_por_hora);
        }

    },

}
</script>
 
<style>
  
   
</style>